module.exports = __webpack_public_path__ + "static/media/ev6.afbf2db8.webp";